import { useCallback, useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import TourAsiaCampaignProfileImage from './TourAsiaCampaignProfileImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import TourTermsAndConditionsModal from 'components/OfferPage/TourV2/TourTermsAndConditionsModal'
import { getTourCampaignConfig } from 'constants/tours'

function TourAsiaCampaignSearchBanner() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const tourCampaignConfig = getTourCampaignConfig(intl)
  const showTermsAndConditionsModal = useCallback(() => {
    showModal(<TourTermsAndConditionsModal
      termsAndConditions={tourCampaignConfig.tiers[0]?.termsAndConditions}
    />)
  }, [showModal, tourCampaignConfig])

  return <Group fullWidth direction="horizontal" verticalAlign="center" gap={20} horizontalAlign="center">
    <TourAsiaCampaignProfileImage />
    <VerticalSpacer gap={4}>
      <Heading variant="heading2" colour="static-white"><FormattedMessage
        id="F3UrcM-xq7HuqlO-QuBR"
        defaultMessage="Asia Tours on Sale"
        description="Section heading for tour Asia campaign on the search page"
      />
      </Heading>
      <Group direction="vertical" tabletDirection="horizontal" tabletGap={12}>
        <BodyText variant="large" colour="static-white"><FormattedMessage
          id="S2oPbAdGY_kqHiaNNe1P"
          defaultMessage="Use code TOURASIA5 for up to $1,550 off select departures. Limited time only!"
          description="Promotional savings message for tour Asia campaign on search page"
        />
        </BodyText>
        <TextLink colour="static-white" onClick={showTermsAndConditionsModal}>{intl.formatMessage({
          id: 'vRefrucI2vD3aEtVHB2T',
          defaultMessage: 'Learn more',
          description: 'Link to learn more about tour Asia campaign on search page',
        })}
        </TextLink>
      </Group>
    </VerticalSpacer>
  </Group>
}

export default TourAsiaCampaignSearchBanner
